import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import { getSignatureDetailsApi } from "../../../api/request/clients/clients";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/clients/signature/signature";
import SignatureAuditModal from "../../reports/components/SignatureAuditModal";
import Templates from "../../../assets/Templates";
import View from "../../../assets/View";
import GlobalTooltip from "../../../components/common/GlobalTooltip";

const ViewSignatureModal = ({ isOpen, setIsOpen, clientId }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [signatureOpen, setSignatureOpen] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedSign, setSelectedSign] = useState([]);

  const getSignatureReport = async () => {
    try {
      setIsLoading(true);
      const { data } = await getSignatureDetailsApi({
        client_id: clientId,
        page: currentPage,
      });
      if (data?.status)
        setData(
          data?.data?.map((item) => ({
            ...item,
            fileNumber: item?.file?.file_number,
            fileName: item?.file?.service_name_slug,
            action: (
              <div className="flex gap-3 items-center">
                <GlobalTooltip title={"View Signature"}>
                  <a
                    href={item?.path || "#"}
                    target={item?.path && "_blank"}
                    className="font-medium text-blue-500"
                  >
                    <View />
                  </a>
                </GlobalTooltip>
                <GlobalTooltip title={"View Signature Audit Report"}>
                  <div
                    onClick={() => {
                      setSelectedSign(item);
                      setSignatureOpen(true);
                    }}
                  >
                    <Templates />
                  </div>
                </GlobalTooltip>
              </div>
            ),
          }))
        );
      setTotal(data?.total_record);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (clientId) getSignatureReport();
  }, [currentPage, isOpen]);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination?.current);
  };
  return (
    <>
      <ModalComponent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title={"View Signature"}
        width={1000}
      >
        <div className="mt-5">
          <SkeletonTable
            columns={columns}
            data={data}
            isLoading={isLoading}
            pagination={{
              current: currentPage,
              total: total,
              pageSize: 10,
              showSizeChanger: false,
            }}
            handleTableChange={handleTableChange}
          />
        </div>
      </ModalComponent>

      {/* Signature Audit Report */}
      <SignatureAuditModal
        isOpen={signatureOpen}
        setIsOpen={setSignatureOpen}
        selectedData={selectedSign}
      />
    </>
  );
};

export default ViewSignatureModal;
